import HeroCadecBuild from './HeroCadecBuild';
import { punchingMetalBackgroundImage } from '@/utils/publicHeroFile';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#0e0e0e]"
    >
      {/* 背景: public/images/hero（繰り返しなし・カバー） */}
      <div
        className="absolute inset-0 z-0 min-h-[100dvh] w-full overflow-hidden pointer-events-none bg-[#0e0e0e] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: punchingMetalBackgroundImage(),
        }}
        aria-hidden
      />
      {/* 文字可読用（写真は透けて見える） */}
      <div
        className="absolute inset-0 z-[1] pointer-events-none bg-black/45"
        aria-hidden
      />

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 w-full">
        {/* Credentials */}
        <div className="flex flex-col items-center gap-2 mb-12 max-w-4xl">
          <span
            className="text-center"
            style={{
              color: '#FFFFFF',
              textShadow: '0 1px 12px rgba(0,0,0,0.35)',
              fontFamily: '"Noto Sans JP", sans-serif',
              fontSize: 'clamp(12px, 1.2vw, 16px)',
              fontWeight: 500,
              letterSpacing: '0.18em',
            }}
          >
            青森県並びに八戸市誘致企業
          </span>
          <span
            className="text-center"
            style={{
              color: '#FFFFFF',
              textShadow: '0 1px 10px rgba(0,0,0,0.3)',
              fontFamily: '"Noto Sans JP", sans-serif',
              fontSize: 'clamp(12px, 1.1vw, 16px)',
              fontWeight: 400,
              letterSpacing: '0.1em',
            }}
          >
            一級建築士事務所 ／（社）青森県建築士事務所協会
          </span>
        </div>

        <HeroCadecBuild
          companyName={
            <p
              className="mb-0 font-medium"
              style={{
                fontSize: 'clamp(18px, 2.3vw, 24px)',
                color: '#FFFFFF',
                textShadow: '0 1px 14px rgba(0,0,0,0.35)',
                letterSpacing: '0.25em',
                fontFamily: '"Noto Sans JP", sans-serif',
              }}
            >
              株式会社キャデック
            </p>
          }
        />

        {/* Tagline */}
        <div className="flex items-center gap-5 max-w-3xl">
          <div className="w-8 h-px bg-white/90" />
          <p
            className="text-center"
            style={{
              fontSize: 'clamp(15px, 1.7vw, 20px)',
              color: '#FFFFFF',
              textShadow: '0 1px 12px rgba(0,0,0,0.35)',
              letterSpacing: '0.2em',
              fontFamily: '"Noto Sans JP", sans-serif',
              fontWeight: 500,
            }}
          >
            建築を通じて地域社会に貢献
          </p>
          <div className="w-8 h-px bg-white/90" />
        </div>
      </div>
    </section>
  );
}
